import { defineComponent, openBlock, createBlock, unref, normalizeStyle, withCtx, createElementBlock, Fragment, renderList, resolveDynamicComponent, mergeProps, createCommentVNode } from 'vue';
/* empty css                            */
/* empty css                              */
/* empty css                                          */
import RowContainer from '../component/row-container/row-container.js';
/* empty css                                        */
/* empty css                                                */
import '../_virtual/index.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "editor-footer",
  props: {
    config: {},
    editor: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return __props.config?.footer ? (openBlock(), createBlock(unref(RowContainer), {
        key: 0,
        align: __props.config?.footer?.align,
        style: normalizeStyle(__props.config?.footer?.style)
      }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.config?.footer?.menus, (menu, index) => {
            return openBlock(), createBlock(resolveDynamicComponent(menu.component), mergeProps({ key: index }, { ref_for: true }, menu.props, {
              editor: __props.editor,
              config: __props.config
            }), null, 16, ["editor", "config"]);
          }), 128))
        ]),
        _: 1
      }, 8, ["align", "style"])) : createCommentVNode("", true);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=editor-footer.vue.js.map
